enum FrameworkEnum {
  Laravel = 'laravel',
}

export default FrameworkEnum
